import React, { useState, useMemo, useEffect } from 'react';
import { OptionsType } from '../../utils/customSelectUtils';
import { commonBackInfo, dealwithHashtag } from '../../utils';
import CustomSelect from '../../components/CustomSelect';
import type { SingleCommonType } from '../../types';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { hashtagPlaceholder } from '../../constants/placeholder';
import { useIntl } from 'umi';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function HashtagSelect({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  filterOptions,
  oriDefaultFilter,
  backOriDefaultValue,
  lang,
}: SingleCommonType) {
  // 搜索的数据
  const [searchValue, setSearchValue] = useState('');
  const { formatMessage } = useIntl();
  const options: OptionsType = useMemo(() => {
    return dealwithHashtag(filterOptions, searchValue);
  }, [filterOptions, searchValue]);

  const basicOptions: OptionsType = useMemo(() => {
    return dealwithHashtag(filterOptions);
  }, [filterOptions]);

  const {
    selects: selectHashtag,
    setSelects: setSelectHashtag,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    oriDefaultFilter,
    defaultKey: 'keyword',
    options: basicOptions.map((item) => item.value),
  });

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();
  useEffect(() => {
    const [text, isAll] = getButtonElement();
    onChange?.(
      'hashtag',
      commonBackInfo(
        { keyword: selectHashtag, keyword_kind: ['real_hashtag'] },
        { hashtag: text },
        { isAll, needChangeEntity: true, excludeKeys: ['keyword_kind'] },
      ),
    );
  }, [selectHashtag, formatMessage]);

  return (
    <div className={`hashtag-select-wrapper ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        placeholderText={hashtagPlaceholder[lang]}
        options={options}
        matchButtonWidth={false}
        basicOptions={basicOptions}
        allShowModal="text"
        allLabel={formatMessage({ id: 'Hashtag' })}
        searchInfo={[searchValue, setSearchValue]}
        selectOptionsInfo={[selectHashtag, setSelectHashtag]}
        onClear={() => setSelectHashtag([])}
        pointKey={FilterButtonPoint.hashtag}
      ></CustomSelect>
    </div>
  );
}
